import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import { PROFFIT_SEARCH_WARNING_UNREAD_SLIDE } from '../../../define/consts/proffit_search/proffit_search_service';
import { propShape } from '../../../helpers/custom-prop-types';
import { getProffitSearchValues } from '../../../helpers/profile';
import WarningIcon from '../../Icon/Svg/WarningIcon';
const FolderWarning = (props) => {
    const { profile } = props;
    const { unReadSlideCount } = getProffitSearchValues(profile);
    if (unReadSlideCount <= 0) {
        return null;
    }
    return (_jsxs(Link, Object.assign({ className: 'warning_folder', to: '/proffit_search/receive_folder' }, { children: [_jsxs("div", Object.assign({ className: 'warning_folder_left' }, { children: [_jsx(WarningIcon, {}), _jsx("p", Object.assign({ className: 'warning_folder_text' }, { children: PROFFIT_SEARCH_WARNING_UNREAD_SLIDE }))] })), _jsx("p", Object.assign({ className: 'warning_folder_link' }, { children: "\u53D7\u4FE1\u30D5\u30A1\u30A4\u30EB\u3078" }))] })));
};
FolderWarning.propTypes = {
    profile: propShape().isRequired,
};
export default FolderWarning;
